import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BreadcrumbLink } from '../../../components/breadcrumb/Breadcrumb';

interface BreadcrumbState {
  links: BreadcrumbLink[];
  hide: boolean;
}
const initialState: BreadcrumbState = {
  links: [],
  hide: false,
};
const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    updateLinks(state, action: PayloadAction<BreadcrumbLink[]>) {
      state.links = action.payload;
    },
    hideBreadcrumb(state) {
      state.hide = true;
    },
    showBreadcrumb(state) {
      state.hide = false;
    },
  },
});

export const { hideBreadcrumb, updateLinks, showBreadcrumb } = breadcrumbSlice.actions;
export const breadcrumbReducer = breadcrumbSlice.reducer;
